
<div>
  <yega1-idle-watcher
      v-on:timeout="signOutRedirectHome">
  </yega1-idle-watcher>
  <router-view name="navigation"></router-view>
  <router-view name="main"></router-view>
  <yega1-loading-spinner message="Loading, please wait..."></yega1-loading-spinner>
</div>
